import '../data'


export function param2Obj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  );
}

export function isEmailOrPhone(val){
	return /^([a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+)$|^(\+|[0-9])?([0-9]{5,20})$/.test(val);
}

export function isMobile(val){
  return /^1[2-9]\d{9}$/.test(val+'');
}

export function range(start, end, step=1){
  const arr = [];
  for(let i=start; (step>0? i<end : i>end); i+=step){
    arr.push(i);
  }
  return arr;
}

export function isEmail(val){
  return /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/.test( val );
}

//解析标准化简历详情
export function handleExperiences(experiences, type) {
  let industriesMap = {...METADATA.industry};
  if (experiences) {
    experiences.forEach(function (exp) {
      if (exp.startYear == 0 || exp.startYear == null) {
        exp.startTime = '';
      } else {
        exp.startTime = exp.startYear + '.' + exp.startMonth;
      }

      if (exp.endYear == 9999 || exp.endYear == -1) {
        exp.endTime = '9999.12';
      } else if (exp.endYear == 0 || exp.endYear == null) {
        exp.endTime = '';
      } else {
        exp.endTime = exp.endYear + '.' + exp.endMonth;
      }

      if (type == 'certificate') {
        if (exp.issuedYear == 0) {
          exp.issuedTime = '';
        } else {
          exp.issuedTime = exp.issuedYear + '.' + exp.issuedMonth;
        }
      }

      if (type == 'work') {
        if (typeof exp.industryIds == 'string') {
          exp.industryIds = exp.industryIds ? exp.industryIds.split(',') : [];
          for (let i = exp.industryIds.length - 1; i >= 0; i--) {
            if (!industriesMap[exp.industryIds[i]]) {
              exp.industryIds.splice(i, 1);
            }
          }
        }

        if (typeof exp.profession == 'string') {
          exp.profession = exp.profession ? exp.profession.split(',') : [];
        }

        exp.companyKey = exp.companyLogo;
        exp.companyLogo = exp.companyLogoUrl;
      }

      if (type == 'education') {
        exp.schoolKey = exp.schoolLogo;
        exp.schoolLogo = exp.schoolLogoUrl;
      }
    });
    console.log(experiences);
    return experiences;
  }
}
